
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13415',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13415",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1021",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10061",
  "foundations-components": "static-1.8657",
  "foundations-components-legacy": "static-1.1682",
  "foundations-theming": "static-1.4897",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.92",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8454",
  "hub-http-shared-msw-handlers": "static-1.10805",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11907",
  "I18n": "static-7.1691",
  "jasmine-runner": "static-1.6864",
  "marketplace-discovery-studio-lib": "static-1.812",
  "marketplace-storefront-base": "static-1.13478",
  "quartz": "static-1.7587",
  "react-dlb": "static-1.92",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "static-1.3268",
  "reporting-testing-lib": "static-1.11114",
  "reselect": "static-3.15",
  "settings-ui-lib": "static-1.12945",
  "SharedI18nStrings": "static-1.186",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7769",
  "ui-addon-i18n": "static-1.11562",
  "ui-addon-react-router-dom": "static-1.9945",
  "unified-auth": "static-1.1133",
  "unified-auth-core-lib": "static-1.1415",
  "usage-tracker": "static-1.7729",
  "usage-tracker-core": "static-1.7579",
  "customer-data-property-utils": "static-1.8464",
  "hub-http": "static-1.6625",
  "integrations-lib": "static-1.17298",
  "marketplace-ui-common": "static-1.20955",
  "marketplace-ui-install": "static-1.941",
  "property-management-iframe": "static-1.14349",
  "quartz-config": "static-1.1365",
  "quartz-core": "static-1.6806",
  "quartz-routing": "static-1.1017",
  "quick-fetch": "static-1.4193",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5085",
  "ts-schema": "static-1.4362",
  "ui-universal-auth": "static-1.9619",
  "UIComponents": "static-3.8853",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3864",
  "quartz-webpack": "static-1.3811",
  "bend-plugin-quartz-routing": "static-1.665",
  "ai-components-ui-library": "static-1.9922",
  "codemirror": "static-5.105",
  "foundations-assets": "static-1.5302",
  "pulse": "static-1.1054",
  "react-codemirror": "static-1.11055",
  "ui-extensions-preview-lib": "static-1.820",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4926",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2613",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9841",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.88",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5624",
  "react-virtualized": "static-2.111",
  "StyleGuideUI": "static-3.512",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2948",
  "ui-fonts": "static-1.1169",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-theming": "static-1.3380",
  "foundations-theming-base": "static-1.3882",
  "stylex": "static-1.45",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3565",
  "msw": "static-1.39",
  "msw-config": "static-1.17",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4724",
  "ui-addon-video-player": "static-1.9057",
  "ai-rendering-library": "static-1.11305",
  "chirp-fetch": "static-1.2316",
  "connections-embed-lib": "static-1.1663",
  "copilot-toolkit": "static-1.12043",
  "feedback-loader": "static-1.29974",
  "laboratory-lib": "static-3.7566",
  "marketplace-embed": "static-1.23102",
  "marketplace-ui-details": "static-1.10850",
  "marketplace-ui-reviews": "static-1.20910",
  "marketplace-ui-tracking": "static-1.15125",
  "sanitize-text": "static-1.8573",
  "usage-tracker-multi": "static-1.6143",
  "usage-tracker-session-replay": "static-1.5415",
  "wootric-nps": "static-1.7264",
  "quartz-head": "static-1.1252",
  "web-vitals": "static-1.18",
  "apollo-link-hub-http": "static-2.5019",
  "immer": "static-1.104",
  "immerable": "static-1.4558",
  "highcharts": "static-8.114",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2781",
  "reporting-data": "static-1.69181",
  "cssUtils": "static-1.1037",
  "flux-actions": "static-1.378",
  "react-colorpicker": "static-2.10628",
  "react-dnd-compat": "static-1.5027",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10787",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7719",
  "icons": "static-2.699",
  "marketplace-ui-apps-core": "static-1.19487",
  "storybook-react": "static-1.43",
  "trellis-story-utils": "static-1.4921",
  "foundations-components-test-utils": "static-1.6140",
  "quartz-i18n": "static-1.1262",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.663",
  "ads-unified-auth-lib": "static-1.1764",
  "custom-vendor-connection-lib": "static-1.183",
  "google-sheets-integration-lib": "static-1.1228",
  "microsoft-drive-auth-lib": "static-1.391",
  "surveymonkey-integration-lib": "static-1.760",
  "slack-ui-library": "static-1.10813",
  "fsm": "static-1.4170",
  "customer-data-objects": "static-1.8109",
  "property-translator": "static-1.5796",
  "hs-locale-management": "static-1.362",
  "frontend-preferences-client": "static-1.8334",
  "hs-promise-utils": "static-1.6006",
  "hubspot-apollo-client": "static-1.5290",
  "integrations-error-boundary-lib": "static-1.14713",
  "integrations-tracking-lib": "static-1.6027",
  "native-integrations-shared-strings": "static-1.8178",
  "sanitize": "static-1.4888",
  "superstore": "static-1.5175",
  "ui-shepherd-react": "static-3.10690",
  "ai-settings-ui-library": "static-1.8495",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4929",
  "immutable-less": "static-1.5066",
  "marketplace-ui-client-types": "static-1.18362",
  "nav-meta": "static-1.30695",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18508",
  "ui-product-approvals-common": "static-1.1424",
  "ai-studio-lib": "static-1.12645",
  "hubspot-prosemirror": "static-1.19178",
  "integrations-reconnect-lib": "static-1.636",
  "ui-addon-iframeable": "static-1.9494",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-product-approvals": "static-1.29529",
  "ui-tool-access": "static-1.10571",
  "inbound-db-properties-service-client": "static-1.4110",
  "property-management-common": "static-1.6637",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "static-1.1262",
  "quartz-test": "static-1.1262",
  "quartz-tracking": "static-1.966",
  "trellis-components": "static-1.2967",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.495",
  "HubStyle": "static-2.12214",
  "bender-build-tools": "static-1.3513",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.116",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23499",
  "ContentUtils": "static-1.69342",
  "customer-data-objects-ui-components": "static-1.13445",
  "sassPrefix": "static-1.304",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.557",
  "batch-promise": "static-1.1961",
  "event-emitter": "static-1.1375",
  "fast-json-patch": "static-1.73",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5851",
  "magpie-types": "static-1.5311",
  "stylex-utils": "static-1.158",
  "trellis-theming": "static-1.1397",
  "avatar-components": "static-1.2899",
  "breeze-engine-core": "static-1.1283",
  "breeze-onboarding-components": "static-1.956",
  "customer-data-filters-ui": "static-1.41214",
  "customer-data-reference-ui-components": "static-1.13583",
  "data-integrations-breeze": "static-1.187",
  "embedded-academy-lib": "static-1.15833",
  "ExportDialog": "static-6.10789",
  "global-styles-ai-lib": "static-1.383",
  "highlight.js": "static-1.89",
  "marketplace-embed-ba": "static-1.805",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42261",
  "reporting-snowflake": "static-1.57797",
  "reporting-ui-components": "static-2.66450",
  "reporting-visualizations": "static-1.61255",
  "trial-components-library": "static-1.14293",
  "ui-addon-teams": "static-1.21968",
  "upgrade-components-lib": "static-1.651",
  "navigation-components": "static-1.19058",
  "breeze-engine-lib": "static-1.2005",
  "simple-logging-lib": "static-1.3468",
  "nudge-client-utils": "static-1.3315",
  "fail-safe": "static-1.369",
  "app-governance-lib": "static-1.2583",
  "developer-experience-shared-components": "static-1.10953",
  "purchase-motions-components": "static-1.6559",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10625",
  "usage-tracker-anonymous": "static-1.6146",
  "usage-tracker-public": "static-1.7540",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3742",
  "persist-promise": "static-1.4118",
  "reference-resolvers": "static-1.8594",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4332",
  "hubspot-apollo-cache": "static-1.749",
  "universal-page-editor-lib": "static-1.3426",
  "final-form": "static-1.82",
  "redux-toolkit": "static-1.81",
  "simple-data-table": "static-1.3722",
  "merchandise-lib": "static-1.283",
  "onboarding-scopes": "static-1.6868",
  "ui-addon-draggable": "static-3.5162",
  "content-assistance-lib": "static-1.8342",
  "content-media-capture": "static-1.5670",
  "customer-data-ui-utilities": "static-1.10248",
  "emoji-mart": "static-3.6",
  "file-manager-components": "static-1.24739",
  "growth-payments-core": "static-1.26394",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3303",
  "payment-link-components": "static-1.24336",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20469",
  "ui-addon-emoji-picker": "static-1.10283",
  "ui-business-units-lib": "static-1.9511",
  "video-components-external": "static-1.12328",
  "video-data-lib": "static-1.35986",
  "navigation-messaging": "static-1.8385",
  "collaboration-sidebar": "static-1.58941",
  "trellis-ext-dnd": "static-1.455",
  "crm-component-utils": "static-1.40058",
  "crm-properties-common-lib": "static-1.6304",
  "customer-data-properties": "static-1.52882",
  "external-options-client-types": "static-1.4411",
  "framework-data-schema-resolvers": "static-1.7309",
  "property-value-citations": "static-1.3496",
  "reference-resolvers-lite": "static-1.8521",
  "hubspotter-http-shared-msw-handlers": "static-1.10803",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "cms-field-types": "static-1.5228",
  "content-icons-ui": "static-1.2417",
  "atom": "static-1.5494",
  "idb-keyval": "static-1.54",
  "reactive-lib": "static-1.1139",
  "breeze-artifacts-sdk": "static-1.676",
  "getting-started-shared-tasks": "static-1.19461",
  "onboarding-journeys-lib": "static-1.1141",
  "conversations-skeleton-state": "static-1.7602",
  "crm-message-bus": "static-1.43989",
  "customer-data-filters-ui-msw-helpers": "static-1.23649",
  "events-data-lib": "static-1.663",
  "FormUrlGenerator": "static-2.5129",
  "framework-builder-read-service-client": "static-1.4290",
  "hs-resources": "static-1.611",
  "multi-account-reference-resolvers": "static-1.1420",
  "onboarding-tours": "static-1.17304",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14667",
  "segments-client-types": "static-1.11961",
  "academy-common-lib": "static-1.15293",
  "dashboard-lib": "static-1.83165",
  "hubspot-prosemirror-plugins": "static-1.19170",
  "share-with-third-party-component-lib": "static-1.9125",
  "ui-asset-management-lib": "static-1.11518",
  "user-context": "static-1.5477",
  "reporting-plugins": "static-1.10904",
  "reporting-reports": "static-1.68857",
  "hubs-service-types": "static-1.1680",
  "purchase-motions-api": "static-1.6562",
  "salesImages": "static-1.674",
  "signup-constants": "static-1.19838",
  "nest": "static-1.650",
  "breeze-engine-chat-components": "static-1.983",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.3072",
  "nudge-renderer-utils": "static-1.3391",
  "whisper-core-api": "static-1.7533",
  "bend-plugin-fail-safe": "static-1.320",
  "framework-listing-lib": "static-2.29704",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31645",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "signup-ui-url-generator": "static-2.8475",
  "onboarding-tours-client": "static-1.5519",
  "one-click-checkout": "static-1.651",
  "platform-infra-nav-components": "static-1.7966",
  "subscription-experience-data-types": "static-1.15365",
  "crm-record-cards-service-types": "static-1.3834",
  "location-customization-utils-lib": "static-1.10316",
  "redux-thunk": "static-2.83",
  "react-flip-move": "static-1.82",
  "ui-coaching-tips": "static-1.29505",
  "content-media-composition-data-lib": "static-1.13474",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4841",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3888",
  "seat-types-lib": "static-1.939",
  "ui-addon-opt": "static-4.8796",
  "commerce-tours-lib": "static-1.6780",
  "growth-onboarding-reliability": "static-1.5498",
  "sales-checkout-service-client": "static-1.3945",
  "data-token-picker": "static-1.17042",
  "FileManagerLib": "static-1.40379",
  "content-media-compositions": "static-2.17481",
  "media-bridge-lib": "static-1.19557",
  "chatspot-widget-iframe": "static-1.23490",
  "collaboration-sidebar-common": "static-1.3738",
  "marketing-platform-lib": "static-1.7307",
  "dnd-kit": "static-1.20",
  "card-properties-lib": "static-1.45217",
  "commerce-subscription-lib": "static-1.37991",
  "crm-actions": "static-1.6766",
  "crm-cards-sdk": "static-1.44874",
  "customer-data-properties-shared-msw-handlers": "static-1.10132",
  "customer-data-tracking": "static-1.7288",
  "calling-global-api": "static-1.66011",
  "calling-internal-common": "static-1.31738",
  "calling-lifecycle-internal": "static-1.67393",
  "calling-lifecycle-messages": "static-1.59686",
  "commerce-products-lib": "static-1.10762",
  "conditional-properties-service-client": "static-1.4084",
  "crm-index-visualization-core": "static-1.4678",
  "crm-links": "static-1.6719",
  "crm-pipelines-api-client-types": "static-1.4415",
  "formula-editor": "static-1.14933",
  "google-libphonenumber": "static-1.48",
  "inbounddb-objects-service-types": "static-1.4492",
  "meetings-icalendar-utils-lib": "static-1.1053",
  "multi-currency-client-types": "static-1.3979",
  "object-builder-ui-client": "static-1.49911",
  "pipeline-validation-client-types": "static-1.4251",
  "smart-data-capture-core": "static-1.352",
  "smart-property-lib": "static-1.8522",
  "tiered-pricing": "static-1.2142",
  "topics-actions-lib": "static-1.591",
  "ui-addon-form-validation": "static-1.11338",
  "zustand": "static-1.88",
  "fdsr-migration-layer": "static-1.428",
  "framework-data-schema-quick-fetch": "static-1.7214",
  "restore-request-side-panel-lib": "static-1.1913",
  "growth-data-modal": "static-1.6049",
  "growth-onboarding-confetti": "static-1.3479",
  "growth-onboarding-next-action-utils": "static-1.2885",
  "onboarding-tours-utils": "static-1.1371",
  "ui-shepherd-tracker": "static-1.8071",
  "crm-index-associations-lib": "static-1.6864",
  "academy-service-client": "static-1.4108",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40238",
  "SafeStorage": "static-1.4810",
  "video-embed": "static-1.36820",
  "redux-actions": "static-3.73",
  "EmailSignatureEditor": "static-1.25156",
  "viral-links-lib": "static-1.7496",
  "nested-table": "static-1.652",
  "timezone-utils": "static-2.5647",
  "getting-started-shared-tasks-store": "static-1.18579",
  "campaign-roi-lib": "static-1.10651",
  "campaigns-utils-lib": "static-1.3649",
  "ui-addon-calendars": "static-2.5778",
  "customer-data-views-management": "static-1.26220",
  "framework-data-table": "static-2.12744",
  "nudge-custom-ui-functions": "static-1.1659",
  "switchboard-lib": "static-1.638",
  "access-check-ui-lib": "static-1.1788",
  "app-users-service-client": "static-1.6035",
  "app-users-service-types": "static-1.5443",
  "mini-checkout-client": "static-1.27746",
  "onboarding-utils": "static-1.5785",
  "permissions-shared-i18n-strings-fe": "static-1.2142",
  "ui-coaching-tips-shared-config": "static-1.29490",
  "checkout-sdk": "static-3.24589",
  "payment-method-components": "static-1.7262",
  "touchless-buying-components": "static-1.6457",
  "upgrade-catalog-service-types": "static-1.3842",
  "edison-service-client-types": "static-1.810",
  "growth-onboarding-feedback-components": "static-1.6999",
  "audio-components": "static-1.6490",
  "FileManagerImages": "static-1.37890",
  "video-components": "static-1.14330",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.93082",
  "customer-data-sidebar": "static-2.46922",
  "enrichment-lib": "static-1.786",
  "ui-addon-draggable-compat": "static-2.4678",
  "universal-record-utils-lib": "static-1.2238",
  "commerce-billing-lib": "static-1.20432",
  "commerce-shared-components-lib": "static-1.19474",
  "commerce-tools-ui-lib": "static-1.11228",
  "crm-fe-perf": "static-1.23311",
  "calling-error-reporting": "static-1.31745",
  "shared-worker-versioning": "static-1.11457",
  "calling-usage-tracker": "static-1.6950",
  "voice-sms-access-library": "static-1.2311",
  "commerce-permissions": "static-1.1192",
  "products-iframe-lib": "static-1.8798",
  "products-ui-components-shared-msw-handlers": "static-1.11187",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10888",
  "sales-views-client-types": "static-1.4675",
  "bark-lib": "static-1.16946",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.802",
  "policy-lib": "static-1.7222",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10951",
  "onboarding-data-sync-lib": "static-1.2742",
  "growth-onboarding-next-action-components": "static-1.2913",
  "user-context-client": "static-1.4924",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4932",
  "outpost": "static-1.4550",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22272",
  "sales-email-signature-service-client": "static-1.4264",
  "ts-utils-lib": "static-1.564",
  "copilot-messaging": "static-1.2293",
  "crm-export-dialog": "static-1.6694",
  "crm-index-ui-shimmer": "static-1.2881",
  "crm-view-components": "static-1.1401",
  "react-beautiful-dnd": "static-1.74",
  "customer-data-associations": "static-1.7747",
  "tasks-actions-lib": "static-1.334",
  "InboxConnectUtils": "static-4.15747",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.47045",
  "hub-http-rxjs": "static-1.865",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4407",
  "company-details-components": "static-1.6621",
  "react-performance-metrics-lib": "static-1.968",
  "pricing-pages-ui-components": "static-1.16317",
  "quote-checkout-service-types": "static-1.3874",
  "social-insights-client-types": "static-1.22833",
  "crm_universal": "static-1.22639",
  "customer-data-email": "static-1.18589",
  "card-payment-highlight-lib": "static-1.38202",
  "commerce-contract-lib": "static-1.13647",
  "invoices-highlight-card-lib": "static-1.56053",
  "orders-highlight-card-lib": "static-1.22397",
  "products-highlight-card-lib": "static-1.19045",
  "quotes-highlight-card-lib": "static-1.72988",
  "crm-source-interpretation-lib": "static-1.5745",
  "data-agent-test-utils": "static-1.346",
  "data-agent-utils": "static-1.815",
  "enrichment-settings-lib": "static-1.131",
  "crm-object-search-query-utilities": "static-1.10372",
  "utility-belt": "static-1.2951",
  "payments-enrollment-embed-lib": "static-1.24095",
  "stripe-embedded-components": "static-1.8153",
  "customer-data-rte": "static-1.33807",
  "cv-backend-services": "static-1.1605",
  "growth-onboarding-empty-states": "static-1.6444",
  "payments-post-enroll-local-storage-lib": "static-1.5519",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39078",
  "calling-orchestration-schema": "static-1.37088",
  "react-reducer-toolkit": "static-1.16566",
  "meetings-connect-utils-lib": "static-1.8032",
  "hub-http-contrib": "static-1.3443",
  "ui-addon-sales-email": "static-1.5619",
  "access-control-lib": "static-1.10844",
  "EmailComponents": "static-1.55744",
  "EmailData": "static-1.54422",
  "messaging-base-table-lib": "static-1.703",
  "redux-less": "static-2.9877",
  "company-details-service-types": "static-1.4359",
  "segments-query-core": "static-1.1844",
  "pricing-pages-api": "static-1.16182",
  "sequences-lib": "static-1.8683",
  "ui-gdpr-components": "static-1.10649",
  "products-ui-components": "static-1.41280",
  "reporting-enablement": "static-1.24054",
  "accounting-integrations-ui-components": "static-1.7712",
  "invoices-ui-lib": "static-1.56069",
  "commerce-products-api": "static-1.2837",
  "invoices-iframe-lib": "static-1.58127",
  "quotes-modal-lib": "static-1.103666",
  "quotes-ui-lib": "static-1.81709",
  "stripe-connect-js": "static-1.81",
  "draft-content-plugins": "static-1.29063",
  "ContentComponents": "static-2.72298",
  "ContentData": "static-1.69417",
  "marketing-email-service-types": "static-1.2177",
  "messaging-editing-lib": "static-1.47360",
  "messaging-usage-based-billing-components-lib": "static-1.2222",
  "automation-ui-source-apps": "static-1.19876",
  "automation-ui-types": "static-1.20794",
  "messaging-types-lib": "static-1.47097",
  "onboarding-settings-client": "static-1.4924",
  "sequences-client-types-lib": "static-1.8540",
  "commerce-tax-lib": "static-1.953",
  "price-books-api": "static-1.1924",
  "price-books-components": "static-1.1982",
  "property-description-translator": "static-1.4237",
  "ramp-editor": "static-1.1076",
  "data-quality-ui-library": "static-1.14170",
  "report-customization-components": "static-1.14106",
  "reporting-filters": "static-1.1196",
  "reporting-insights-lib": "static-1.2810",
  "commerce-analytics-service-client": "static-1.3933",
  "totals-ui-components": "static-1.24472",
  "SalesContentIndexUI": "static-3.9689",
  "advanced-menus-core": "static-1.15729",
  "advanced-menus-lib": "static-1.12512",
  "automation-ui-ubb": "static-1.6710",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7753",
  "data-token-views": "static-1.17023",
  "forms-utils-lib": "static-1.13249",
  "payments-embed-points-lib": "static-1.13758",
  "react-tinymce": "static-1.56169",
  "simple-menus-core": "static-1.15728",
  "simple-menus-lib": "static-1.17245",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55295",
  "tinymce-data": "static-1.41380",
  "tinymce-plugins": "static-1.58409",
  "tinymce-themes": "static-1.57265",
  "ui-brand-identity-lib": "static-1.16789",
  "ui-memberships-settings-lib": "static-1.35078",
  "videoconference-integration-components": "static-1.7445",
  "automation-applications-service-types": "static-1.3698",
  "automation-platform-service-types": "static-1.2709",
  "ContentEditorUI": "static-2.78128",
  "content-whatsapp-service-types": "static-1.641",
  "short-messages-app-service-client": "static-1.4339",
  "web-interactives-components": "static-1.14405",
  "web-interactives-data": "static-1.14406",
  "messaging-shared-utils-lib": "static-1.1671",
  "messaging-user-info-utils-lib": "static-1.1841",
  "email-portal-health-service-types": "static-1.1399",
  "line-items-api": "static-1.1246",
  "merge-modal-lib": "static-1.12926",
  "commerce-totals-service-types": "static-1.4101",
  "FireAlarmUi": "static-1.4803",
  "sales-templates-service-types-lib": "static-1.4453",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22730",
  "automation-ui-usage-tracking": "static-1.22193",
  "data-studio-ubb": "static-1.3711",
  "interframe": "static-3.5157",
  "layout-dnd-components": "static-1.13131",
  "layout-dnd-utils": "static-1.12106",
  "NamespacedHubStyle": "static-2.9326",
  "campaigns-lib": "static-1.27805",
  "content-management-data-lib": "static-1.6138",
  "copilot-plugins": "static-1.12015",
  "cta-picker": "static-1.37165",
  "customer-agent-discovery-components-lib": "static-1.4165",
  "editor-components": "static-1.13805",
  "editor-iframe-lib": "static-1.8930",
  "error-messaging-js": "static-1.5555",
  "FormsCommonComponents": "static-1.86743",
  "layout-data-lib": "static-1.10431",
  "pictos": "static-7.194",
  "react-transition-group": "static-2.77",
  "redux-request-state": "static-1.11055",
  "SharedLegalStrings": "static-1.2144",
  "smart-content-core": "static-1.43361",
  "smart-content-lib": "static-1.44014",
  "social-composer-lib": "static-1.60492",
  "structured-content-lib": "static-1.26099",
  "theme-previewer-lib": "static-1.54077",
  "tinymce-copilot": "static-1.17363",
  "xray-recommendation-lib": "static-1.8387",
  "automation-ui-routing": "static-1.22151",
  "sql-reporting-client-types": "static-1.5971",
  "attribution-lib": "static-1.42927",
  "voice-agents-components": "static-1.3979",
  "forms-ai-lib": "static-1.4900",
  "codemirror-dlb": "static-1.59687",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6862",
  "calling-orchestration-shared-library": "static-1.36863"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13415",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1021",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10061",
  "foundations-components": "/foundations-components/static-1.8657",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1682",
  "foundations-theming": "/foundations-theming/static-1.4897",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.92",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8454",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10805",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11907",
  "I18n": "/I18n/static-7.1691",
  "jasmine-runner": "/jasmine-runner/static-1.6864",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.812",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13478",
  "quartz": "/quartz/static-1.7587",
  "react-dlb": "/react-dlb/static-1.92",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3268",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11114",
  "reselect": "/reselect/static-3.15",
  "settings-ui-lib": "/settings-ui-lib/static-1.12945",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7769",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11562",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9945",
  "unified-auth": "/unified-auth/static-1.1133",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1415",
  "usage-tracker": "/usage-tracker/static-1.7729",
  "usage-tracker-core": "/usage-tracker-core/static-1.7579",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "hub-http": "/hub-http/static-1.6625",
  "integrations-lib": "/integrations-lib/static-1.17298",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20955",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.941",
  "property-management-iframe": "/property-management-iframe/static-1.14349",
  "quartz-config": "/quartz-config/static-1.1365",
  "quartz-core": "/quartz-core/static-1.6806",
  "quartz-routing": "/quartz-routing/static-1.1017",
  "quick-fetch": "/quick-fetch/static-1.4193",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5085",
  "ts-schema": "/ts-schema/static-1.4362",
  "ui-universal-auth": "/ui-universal-auth/static-1.9619",
  "UIComponents": "/UIComponents/static-3.8853",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3864",
  "quartz-webpack": "/quartz-webpack/static-1.3811",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.665",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9922",
  "codemirror": "/codemirror/static-5.105",
  "foundations-assets": "/foundations-assets/static-1.5302",
  "pulse": "/pulse/static-1.1054",
  "react-codemirror": "/react-codemirror/static-1.11055",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.820",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4926",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2613",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9841",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5624",
  "react-virtualized": "/react-virtualized/static-2.111",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2948",
  "ui-fonts": "/ui-fonts/static-1.1169",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3380",
  "foundations-theming-base": "/foundations-theming-base/static-1.3882",
  "stylex": "/stylex/static-1.45",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3565",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.17",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4724",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ai-rendering-library": "/ai-rendering-library/static-1.11305",
  "chirp-fetch": "/chirp-fetch/static-1.2316",
  "connections-embed-lib": "/connections-embed-lib/static-1.1663",
  "copilot-toolkit": "/copilot-toolkit/static-1.12043",
  "feedback-loader": "/feedback-loader/static-1.29974",
  "laboratory-lib": "/laboratory-lib/static-3.7566",
  "marketplace-embed": "/marketplace-embed/static-1.23102",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10850",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20910",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15125",
  "sanitize-text": "/sanitize-text/static-1.8573",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6143",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5415",
  "wootric-nps": "/wootric-nps/static-1.7264",
  "quartz-head": "/quartz-head/static-1.1252",
  "web-vitals": "/web-vitals/static-1.18",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4558",
  "highcharts": "/highcharts/static-8.114",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2781",
  "reporting-data": "/reporting-data/static-1.69181",
  "cssUtils": "/cssUtils/static-1.1037",
  "flux-actions": "/flux-actions/static-1.378",
  "react-colorpicker": "/react-colorpicker/static-2.10628",
  "react-dnd-compat": "/react-dnd-compat/static-1.5027",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10787",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7719",
  "icons": "/icons/static-2.699",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19487",
  "storybook-react": "/storybook-react/static-1.43",
  "trellis-story-utils": "/trellis-story-utils/static-1.4921",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6140",
  "quartz-i18n": "/quartz-i18n/static-1.1262",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.663",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1764",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.183",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1228",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.391",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.760",
  "slack-ui-library": "/slack-ui-library/static-1.10813",
  "fsm": "/fsm/static-1.4170",
  "customer-data-objects": "/customer-data-objects/static-1.8109",
  "property-translator": "/property-translator/static-1.5796",
  "hs-locale-management": "/hs-locale-management/static-1.362",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8334",
  "hs-promise-utils": "/hs-promise-utils/static-1.6006",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5290",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14713",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6027",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8178",
  "sanitize": "/sanitize/static-1.4888",
  "superstore": "/superstore/static-1.5175",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10690",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8495",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4929",
  "immutable-less": "/immutable-less/static-1.5066",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18362",
  "nav-meta": "/nav-meta/static-1.30695",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18508",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1424",
  "ai-studio-lib": "/ai-studio-lib/static-1.12645",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19178",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.636",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9494",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-product-approvals": "/ui-product-approvals/static-1.29529",
  "ui-tool-access": "/ui-tool-access/static-1.10571",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4110",
  "property-management-common": "/property-management-common/static-1.6637",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.4",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.4",
  "quartz-auth": "/quartz-auth/static-1.1262",
  "quartz-test": "/quartz-test/static-1.1262",
  "quartz-tracking": "/quartz-tracking/static-1.966",
  "trellis-components": "/trellis-components/static-1.2967",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.495",
  "HubStyle": "/HubStyle/static-2.12214",
  "bender-build-tools": "/bender-build-tools/static-1.3513",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.116",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23499",
  "ContentUtils": "/ContentUtils/static-1.69342",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13445",
  "sassPrefix": "/sassPrefix/static-1.304",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.557",
  "batch-promise": "/batch-promise/static-1.1961",
  "event-emitter": "/event-emitter/static-1.1375",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5851",
  "magpie-types": "/magpie-types/static-1.5311",
  "stylex-utils": "/stylex-utils/static-1.158",
  "trellis-theming": "/trellis-theming/static-1.1397",
  "avatar-components": "/avatar-components/static-1.2899",
  "breeze-engine-core": "/breeze-engine-core/static-1.1283",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.956",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41214",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13583",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.187",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15833",
  "ExportDialog": "/ExportDialog/static-6.10789",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.383",
  "highlight.js": "/highlight.js/static-1.89",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.805",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42261",
  "reporting-snowflake": "/reporting-snowflake/static-1.57797",
  "reporting-ui-components": "/reporting-ui-components/static-2.66450",
  "reporting-visualizations": "/reporting-visualizations/static-1.61255",
  "trial-components-library": "/trial-components-library/static-1.14293",
  "ui-addon-teams": "/ui-addon-teams/static-1.21968",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.651",
  "navigation-components": "/navigation-components/static-1.19058",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2005",
  "simple-logging-lib": "/simple-logging-lib/static-1.3468",
  "nudge-client-utils": "/nudge-client-utils/static-1.3315",
  "fail-safe": "/fail-safe/static-1.369",
  "app-governance-lib": "/app-governance-lib/static-1.2583",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10953",
  "purchase-motions-components": "/purchase-motions-components/static-1.6559",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10625",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6146",
  "usage-tracker-public": "/usage-tracker-public/static-1.7540",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3742",
  "persist-promise": "/persist-promise/static-1.4118",
  "reference-resolvers": "/reference-resolvers/static-1.8594",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4332",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.749",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3426",
  "final-form": "/final-form/static-1.82",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "simple-data-table": "/simple-data-table/static-1.3722",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "onboarding-scopes": "/onboarding-scopes/static-1.6868",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5162",
  "content-assistance-lib": "/content-assistance-lib/static-1.8342",
  "content-media-capture": "/content-media-capture/static-1.5670",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10248",
  "emoji-mart": "/emoji-mart/static-3.6",
  "file-manager-components": "/file-manager-components/static-1.24739",
  "growth-payments-core": "/growth-payments-core/static-1.26394",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3303",
  "payment-link-components": "/payment-link-components/static-1.24336",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20469",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10283",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9511",
  "video-components-external": "/video-components-external/static-1.12328",
  "video-data-lib": "/video-data-lib/static-1.35986",
  "navigation-messaging": "/navigation-messaging/static-1.8385",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58941",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.455",
  "crm-component-utils": "/crm-component-utils/static-1.40058",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6304",
  "customer-data-properties": "/customer-data-properties/static-1.52882",
  "external-options-client-types": "/external-options-client-types/static-1.4411",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7309",
  "property-value-citations": "/property-value-citations/static-1.3496",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8521",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10803",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "cms-field-types": "/cms-field-types/static-1.5228",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "atom": "/atom/static-1.5494",
  "idb-keyval": "/idb-keyval/static-1.54",
  "reactive-lib": "/reactive-lib/static-1.1139",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.676",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19461",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1141",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-message-bus": "/crm-message-bus/static-1.43989",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23649",
  "events-data-lib": "/events-data-lib/static-1.663",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5129",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4290",
  "hs-resources": "/hs-resources/static-1.611",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1420",
  "onboarding-tours": "/onboarding-tours/static-1.17304",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14667",
  "segments-client-types": "/segments-client-types/static-1.11961",
  "academy-common-lib": "/academy-common-lib/static-1.15293",
  "dashboard-lib": "/dashboard-lib/static-1.83165",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19170",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9125",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11518",
  "user-context": "/user-context/static-1.5477",
  "reporting-plugins": "/reporting-plugins/static-1.10904",
  "reporting-reports": "/reporting-reports/static-1.68857",
  "hubs-service-types": "/hubs-service-types/static-1.1680",
  "purchase-motions-api": "/purchase-motions-api/static-1.6562",
  "salesImages": "/salesImages/static-1.674",
  "signup-constants": "/signup-constants/static-1.19838",
  "nest": "/nest/static-1.650",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.983",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3072",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3391",
  "whisper-core-api": "/whisper-core-api/static-1.7533",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.320",
  "framework-listing-lib": "/framework-listing-lib/static-2.29704",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31645",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8475",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5519",
  "one-click-checkout": "/one-click-checkout/static-1.651",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7966",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15365",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10316",
  "redux-thunk": "/redux-thunk/static-2.83",
  "react-flip-move": "/react-flip-move/static-1.82",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29505",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13474",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4841",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3888",
  "seat-types-lib": "/seat-types-lib/static-1.939",
  "ui-addon-opt": "/ui-addon-opt/static-4.8796",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6780",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5498",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3945",
  "data-token-picker": "/data-token-picker/static-1.17042",
  "FileManagerLib": "/FileManagerLib/static-1.40379",
  "content-media-compositions": "/content-media-compositions/static-2.17481",
  "media-bridge-lib": "/media-bridge-lib/static-1.19557",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23490",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3738",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7307",
  "dnd-kit": "/dnd-kit/static-1.20",
  "card-properties-lib": "/card-properties-lib/static-1.45217",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37991",
  "crm-actions": "/crm-actions/static-1.6766",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44874",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10132",
  "customer-data-tracking": "/customer-data-tracking/static-1.7288",
  "calling-global-api": "/calling-global-api/static-1.66011",
  "calling-internal-common": "/calling-internal-common/static-1.31738",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67393",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59686",
  "commerce-products-lib": "/commerce-products-lib/static-1.10762",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4084",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4678",
  "crm-links": "/crm-links/static-1.6719",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4415",
  "formula-editor": "/formula-editor/static-1.14933",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4492",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1053",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3979",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49911",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4251",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.352",
  "smart-property-lib": "/smart-property-lib/static-1.8522",
  "tiered-pricing": "/tiered-pricing/static-1.2142",
  "topics-actions-lib": "/topics-actions-lib/static-1.591",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11338",
  "zustand": "/zustand/static-1.88",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.428",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7214",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1913",
  "growth-data-modal": "/growth-data-modal/static-1.6049",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3479",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2885",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1371",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8071",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6864",
  "academy-service-client": "/academy-service-client/static-1.4108",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40238",
  "SafeStorage": "/SafeStorage/static-1.4810",
  "video-embed": "/video-embed/static-1.36820",
  "redux-actions": "/redux-actions/static-3.73",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25156",
  "viral-links-lib": "/viral-links-lib/static-1.7496",
  "nested-table": "/nested-table/static-1.652",
  "timezone-utils": "/timezone-utils/static-2.5647",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18579",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10651",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3649",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5778",
  "customer-data-views-management": "/customer-data-views-management/static-1.26220",
  "framework-data-table": "/framework-data-table/static-2.12744",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1659",
  "switchboard-lib": "/switchboard-lib/static-1.638",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1788",
  "app-users-service-client": "/app-users-service-client/static-1.6035",
  "app-users-service-types": "/app-users-service-types/static-1.5443",
  "mini-checkout-client": "/mini-checkout-client/static-1.27746",
  "onboarding-utils": "/onboarding-utils/static-1.5785",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2142",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29490",
  "checkout-sdk": "/checkout-sdk/static-3.24589",
  "payment-method-components": "/payment-method-components/static-1.7262",
  "touchless-buying-components": "/touchless-buying-components/static-1.6457",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3842",
  "edison-service-client-types": "/edison-service-client-types/static-1.810",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6999",
  "audio-components": "/audio-components/static-1.6490",
  "FileManagerImages": "/FileManagerImages/static-1.37890",
  "video-components": "/video-components/static-1.14330",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.93082",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46922",
  "enrichment-lib": "/enrichment-lib/static-1.786",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4678",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2238",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20432",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19474",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11228",
  "crm-fe-perf": "/crm-fe-perf/static-1.23311",
  "calling-error-reporting": "/calling-error-reporting/static-1.31745",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11457",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6950",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2311",
  "commerce-permissions": "/commerce-permissions/static-1.1192",
  "products-iframe-lib": "/products-iframe-lib/static-1.8798",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11187",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10888",
  "sales-views-client-types": "/sales-views-client-types/static-1.4675",
  "bark-lib": "/bark-lib/static-1.16946",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.802",
  "policy-lib": "/policy-lib/static-1.7222",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10951",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2742",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2913",
  "user-context-client": "/user-context-client/static-1.4924",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4932",
  "outpost": "/outpost/static-1.4550",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22272",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4264",
  "ts-utils-lib": "/ts-utils-lib/static-1.564",
  "copilot-messaging": "/copilot-messaging/static-1.2293",
  "crm-export-dialog": "/crm-export-dialog/static-1.6694",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2881",
  "crm-view-components": "/crm-view-components/static-1.1401",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
  "customer-data-associations": "/customer-data-associations/static-1.7747",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.334",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15747",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.47045",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.865",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4407",
  "company-details-components": "/company-details-components/static-1.6621",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.968",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16317",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3874",
  "social-insights-client-types": "/social-insights-client-types/static-1.22833",
  "crm_universal": "/crm_universal/static-1.22639",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38202",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13647",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.56053",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22397",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.19045",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72988",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5745",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.346",
  "data-agent-utils": "/data-agent-utils/static-1.815",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.131",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10372",
  "utility-belt": "/utility-belt/static-1.2951",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24095",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8153",
  "customer-data-rte": "/customer-data-rte/static-1.33807",
  "cv-backend-services": "/cv-backend-services/static-1.1605",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6444",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5519",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39078",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37088",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16566",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8032",
  "hub-http-contrib": "/hub-http-contrib/static-1.3443",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5619",
  "access-control-lib": "/access-control-lib/static-1.10844",
  "EmailComponents": "/EmailComponents/static-1.55744",
  "EmailData": "/EmailData/static-1.54422",
  "messaging-base-table-lib": "/messaging-base-table-lib/static-1.703",
  "redux-less": "/redux-less/static-2.9877",
  "company-details-service-types": "/company-details-service-types/static-1.4359",
  "segments-query-core": "/segments-query-core/static-1.1844",
  "pricing-pages-api": "/pricing-pages-api/static-1.16182",
  "sequences-lib": "/sequences-lib/static-1.8683",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10649",
  "products-ui-components": "/products-ui-components/static-1.41280",
  "reporting-enablement": "/reporting-enablement/static-1.24054",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7712",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.56069",
  "commerce-products-api": "/commerce-products-api/static-1.2837",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.58127",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103666",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81709",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "draft-content-plugins": "/draft-content-plugins/static-1.29063",
  "ContentComponents": "/ContentComponents/static-2.72298",
  "ContentData": "/ContentData/static-1.69417",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2177",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47360",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2222",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19876",
  "automation-ui-types": "/automation-ui-types/static-1.20794",
  "messaging-types-lib": "/messaging-types-lib/static-1.47097",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4924",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8540",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.953",
  "price-books-api": "/price-books-api/static-1.1924",
  "price-books-components": "/price-books-components/static-1.1982",
  "property-description-translator": "/property-description-translator/static-1.4237",
  "ramp-editor": "/ramp-editor/static-1.1076",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.14170",
  "report-customization-components": "/report-customization-components/static-1.14106",
  "reporting-filters": "/reporting-filters/static-1.1196",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2810",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3933",
  "totals-ui-components": "/totals-ui-components/static-1.24472",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9689",
  "advanced-menus-core": "/advanced-menus-core/static-1.15729",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6710",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7753",
  "data-token-views": "/data-token-views/static-1.17023",
  "forms-utils-lib": "/forms-utils-lib/static-1.13249",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13758",
  "react-tinymce": "/react-tinymce/static-1.56169",
  "simple-menus-core": "/simple-menus-core/static-1.15728",
  "simple-menus-lib": "/simple-menus-lib/static-1.17245",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55295",
  "tinymce-data": "/tinymce-data/static-1.41380",
  "tinymce-plugins": "/tinymce-plugins/static-1.58409",
  "tinymce-themes": "/tinymce-themes/static-1.57265",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16789",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35078",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7445",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3698",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2709",
  "ContentEditorUI": "/ContentEditorUI/static-2.78128",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.641",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4339",
  "web-interactives-components": "/web-interactives-components/static-1.14405",
  "web-interactives-data": "/web-interactives-data/static-1.14406",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1671",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1841",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1399",
  "line-items-api": "/line-items-api/static-1.1246",
  "merge-modal-lib": "/merge-modal-lib/static-1.12926",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4101",
  "FireAlarmUi": "/FireAlarmUi/static-1.4803",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4453",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22730",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22193",
  "data-studio-ubb": "/data-studio-ubb/static-1.3711",
  "interframe": "/interframe/static-3.5157",
  "layout-dnd-components": "/layout-dnd-components/static-1.13131",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12106",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9326",
  "campaigns-lib": "/campaigns-lib/static-1.27805",
  "content-management-data-lib": "/content-management-data-lib/static-1.6138",
  "copilot-plugins": "/copilot-plugins/static-1.12015",
  "cta-picker": "/cta-picker/static-1.37165",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4165",
  "editor-components": "/editor-components/static-1.13805",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8930",
  "error-messaging-js": "/error-messaging-js/static-1.5555",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86743",
  "layout-data-lib": "/layout-data-lib/static-1.10431",
  "pictos": "/pictos/static-7.194",
  "react-transition-group": "/react-transition-group/static-2.77",
  "redux-request-state": "/redux-request-state/static-1.11055",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2144",
  "smart-content-core": "/smart-content-core/static-1.43361",
  "smart-content-lib": "/smart-content-lib/static-1.44014",
  "social-composer-lib": "/social-composer-lib/static-1.60492",
  "structured-content-lib": "/structured-content-lib/static-1.26099",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.54077",
  "tinymce-copilot": "/tinymce-copilot/static-1.17363",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8387",
  "automation-ui-routing": "/automation-ui-routing/static-1.22151",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5971",
  "attribution-lib": "/attribution-lib/static-1.42927",
  "voice-agents-components": "/voice-agents-components/static-1.3979",
  "forms-ai-lib": "/forms-ai-lib/static-1.4900",
  "codemirror-dlb": "/codemirror-dlb/static-1.59687",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6862",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.36863"
}
};
